import request from '@/utils/request';

// 1. 获取应用信息列表
export function fetchAppList(params) {
  return request({
    url: '/ajax/enterprises/' + params.enterpriseID + '/apps',
    method: 'get',
    params: params
  });
}

// 2. 获取应用信息
export function fetchAppInfo(enterpriseID, appKeyID) {
  return request({
    url: '/ajax/enterprises/' + enterpriseID + '/apps/' + appKeyID,
    method: 'get',
    params: { appKeyID: appKeyID }
  });
}

// 3. 更新应用信息
export function putFetchAppInfo(enterpriseID, appKeyID, data) {
  return request({
    url: '/ajax/enterprises/' + enterpriseID + '/apps/' + appKeyID,
    method: 'PUT',
    data: data
  });
}

// 4. 删除应用
export function deleteApp(enterpriseID, appKeyID) {
  return request({
    url: '/ajax/enterprises/' + enterpriseID + '/apps/' + appKeyID,
    method: 'DELETE',
    data: { appKeyID: appKeyID }
  });
}
// 7. 删除应用版本
export function deleteAppVersion(params) {
  return request({
    url:
      '/ajax/enterprises/' +
      params.enterpriseID +
      '/apps/' +
      params.appKeyID +
      '/versions',
    method: 'DELETE',
    data: { version: params.version }
  });
}

// 1. 获取企业信息列表
export function fetchEnterpriseList(params) {
  return request({
    url: '/ajax/enterprises',
    method: 'get',
    params: params
  });
}

// 1. 获取企业信息列表 (管理)
export function fetchEnterpriseListadmin(params) {
  return request({
    url: '/ajax/system/enterprises',
    method: 'get',
    params: params || {
      page: 1,
      size: 99,
      name: ''
    }
  });
}

// 2. 获取制定企业信息
export function fetchEnterpriseInfo(enterpriseID) {
  return request({
    url: '/enterprise-server/enterprises/' + enterpriseID,
    method: 'get'
  });
}

// 3. 编辑企业信息
export function updateEnterpriseInfo(data) {
  return request({
    url: '/ajax/enterprises/' + data.enterprise_id,
    method: 'PUT',
    data: data
  });
}

// 2. 添加企业
export function addEnterprise(data) {
  return request({
    url: '/ajax/enterprises',
    method: 'post',
    data: data
  });
}

// 3. 获取联合云信息列表
export function fetcheJointCloudList(enterpriseID) {
  return request({
    url: '/ajax/enterprises/' + enterpriseID + '/enterprise-clouds',
    method: 'get',
    params: { enterpriseID: enterpriseID }
  });
}

// 4. 获取联合云信息
export function fetcheJointCloudInfo(params) {
  return request({
    url: '/ajax/enterprises/:enterpriseID/enterprise-clouds/:cloudRegistID',
    method: 'get',
    params: params
  });
}

// 5. 绑定联合云信息

export function bindJointCloudInfo(objs) {
  return request({
    url: '/ajax/enterprises/' + objs.enterprise_id + '/enterprise-clouds',
    method: 'post',
    data: objs
  });
}

// 6删除绑定联合云信息

export function deleteCloudInfo(enterpriseID, ID) {
  return request({
    url: '/ajax/enterprises/' + enterpriseID + '/enterprise-clouds/' + ID,
    method: 'DELETE',
    data: { enterpriseID, ID }
  });
}

// 1. 根据联合云ID获取企业信息
export function fetcheJointCloudIDInfo(params) {
  return request({
    url: '/ajax/cloudents',
    method: 'get',
    params: params
  });
}

// 2. 交付应用
export function deliveryApp(objs) {
  return request({
    url: '/ajax/enterprises/' + objs.provider_eid + '/apps/' + objs.app_key_id + '/delivery',
    method: 'post',
    data: objs
  });
}

// 3. 交付记录
export function deliveryrecord(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/apps/' + params.app_key_id + '/dlvrecords',
    method: 'get',
    params: params
  });
}
// 3. 下载记录
export function downloadrecord(params) {
  return request({
    url: '/ajax/enterprises/' + params.ID + '/apps/' + params.app_key_id + '/drecords',
    method: 'get',
    params: params
  });
}


// 4删除下载记录

export function deleteDeliveryRecord(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/apps/' + params.app_key_id + '/delivery/' + params.delivered_id,
    method: 'DELETE'
  });
}



// WEBPACK FOOTER //
// ./src/api/enterpriseAppInfo.js